import ActionTypes from '../constants';

const initialState = {
    accidentTypes: {},
    accidentType: {}
    // loading: false,
};

const accidentTypeReducer = (state = initialState, action) => {
    switch (action.type) {
        // case ActionTypes.LOADING:
        //     return {
        //         ...state,
        //         loading: true
        //     }
        case ActionTypes.GETACCIDENTTYPESUCCESS:
            return {
                ...state,
                accidentTypes: action.payload,
            }
        case ActionTypes.GETACCIDENTTYPEBYIDSUCCESS:
            return {
                ...state,
                accidentType: action.payload,
            }
        default:
            return state;
    }
}

export default accidentTypeReducer;